import { create } from "zustand";
import { listReview } from "@/services/review";

interface ReviewPendingCountState {
  pendingCount: number;
  loading: boolean;
  fetchPendingCount: () => Promise<number>;
  resetPendingCount: () => void;
}

export const useReviewPendingCountStore = create<ReviewPendingCountState>(
  (set, get) => ({
    pendingCount: 0,
    loading: false,

    fetchPendingCount: async () => {
      const { loading, pendingCount } = get();
      if (loading) {
        return pendingCount;
      }

      set({ loading: true });
      try {
        const response = await listReview({
          page: "1",
          size: "0",
          viewScope: "2",
        });
        const nextPendingCount =
          typeof response?.pendingCount === "number"
            ? response.pendingCount
            : Number(response?.pendingCount ?? 0);

        set({
          pendingCount: Number.isFinite(nextPendingCount)
            ? nextPendingCount
            : 0,
          loading: false,
        });

        return Number.isFinite(nextPendingCount) ? nextPendingCount : 0;
      } catch (_error) {
        set({ pendingCount: 0, loading: false });
        return 0;
      }
    },

    resetPendingCount: () => {
      set({ pendingCount: 0, loading: false });
    },
  }),
);
